
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compare/delinea-alternative",
      function () {
        return require("private-next-pages/compare/delinea-alternative.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compare/delinea-alternative"])
      });
    }
  